import { Sizes } from '../../constants/size';
import type { IconProps } from '../../types/icon-props';

export const CircleClose = (props: IconProps) => {
  const { size = 'md', fill = 'var(--grey-1)', stroke = 'var(--grey-1)', ...rest } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={Sizes[size]}
      height={Sizes[size]}
      viewBox="0 0 16 16"
      fill={fill}
      {...rest}
    >
      <path style={{ fill: 'none' }} d="M0 0h16v16H0z" />
      <g>
        <path
          d="M6.4 0a6.4 6.4 0 1 0 6.4 6.4A6.419 6.419 0 0 0 6.4 0zm2.8 8.08L8.08 9.2 6.4 7.52 4.72 9.2 3.6 8.08 5.28 6.4 3.6 4.72 4.72 3.6 6.4 5.28 8.08 3.6 9.2 4.72 7.52 6.4z"
          transform="translate(1.5 1.5)"
        />
      </g>
    </svg>
  );
};

CircleClose.displayName = 'CircleClose';
